import React, { PureComponent } from 'react';
import NavLink from './NavLink';

const FS2_LOGO = require('../../../res/fast-scout-full.svg');

export default class FastScoutLink extends PureComponent {
  render() {
    const { className, style } = this.props;

    return (
      <NavLink
        className={className}
        style={style}
        href={window.config.FASTSCOUT_URL}
        target='_self'
        page={null}
        id="fastScoutLink"
      >
        <img
          alt="fastScout"
          style={{ height: '100%', ...style }}
          key="fast-scout-logo"
          className={'fast-scout-name-logo'}
          src={FS2_LOGO}/>
      </NavLink>
    );
  }
}